import { head } from 'framer-motion/client';
import { generateSectionId } from '../../../HelpCenterComponents/ArticleLayout';

export const AlliancesContentBody = ({ activeLeft }) => {
  const contentData = {
    0: {
      sections: [
        {
          type: 'text',
          heading: 'SpatialGrid Alliances',
          paragraphs: [
            'At Spatial Grid, we believe that building strategic alliances with service and technology partners will help us provide value to our customers. Our Alliances program is aimed at creating strategic partnerships with internal teams, external vendors, or complementary businesses to improve customer support, reduce costs, and enhance the overall customer experience.',
            'We are looking to build collaborations to transform the help center from a simple FAQ page into a robust support ecosystem, often leading to higher customer retention and faster issue resolution.',
          ],
        },
      ],
    },
    1: {
      sections: [
        {
          type: 'text',
          heading: 'Type of Alliances',
          paragraphs: [],
        },
        {
          type: 'list',
          items: [
            {
              title: 'Technology & Vendor Alliances',
              description:
                'Partnering with CRM, help desk software providers (e.g., Zendesk, HubSpot), and AI chatbot developers to streamline ticketing and automate responses.',
            },
            {
              title: 'Community Partnerships',
              description:
                'Working with community managers or expert users to build peer-to-peer forums where users help each other.',
            },
            {
              title: 'Service Partnerships',
              description:
                'Collaborating with complementary businesses or even competitors to offer a more holistic, integrated support experience, such as a hardware provider partnering with a software troubleshooting firm.',
            },
          ],
        },
      ],
    },
    2: {
      sections: [
        {
          type: 'text',
          heading: 'Alliances Objectives',
          paragraphs: [],
        },
        {
          type: 'list',
          items: [
            {
              title: 'Shared goals',
              description:
                'We believe that both parties should benefit, such as increased customer retention for both firms or shared revenue agreements.',
            },
            {
              title: 'Community Partnerships',
              description:
                'We are looking to build collaborations to transform the help center from a simple FAQ page into a robust supp',
            },
            {
              title: 'Roles & Responsibilities',
              description:
                'Clearly outline who is responsible for updating content, who manages technical issues, and who handles customer communication.',
            },
            {
              title: 'Data Sharing & Integration',
              description:
                'Seamless integration between systems (e.g., integrating a partners troubleshooting tool into your Help Center portal) ensures consistent, contextual support.',
            },
            {
              title: 'Regular Communication',
              description:
                'We will schedule weekly or monthly meetings to review metrics, address challenges, and update strategies.',
            },
          ],
        },
      ],
    },
    3: {
      sections: [
        {
          type: 'text',
          heading: 'Benefits',
          paragraphs: [],
        },
        {
          type: 'list',
          items: [
            {
              title: 'Reduced Operational Costs',
              description:
                'By automating processes, utilizing chatbots, and enabling self-service, companies can significantly reduce the load on support agents.',
            },
            {
              title: 'Improved Efficiency',
              description:
                'A comprehensive, partner-vetted knowledge base allows customers to solve issues independently, preventing the need for support tickets.',
            },
            {
              title: 'Better Customer Insights',
              description:
                'Partners can provide data on customer pain points that your own team might miss, allowing for a more proactive support approach.',
            },
            {
              title: 'Enhanced Customer Experience',
              description:
                'We believe strong alliances allow for 24/7, multi-channel, or specialized support will help with better experience for the customer.',
            },
          ],
        },
      ],
    },
  };

  const currentContent = contentData[activeLeft] || contentData[0];

  return (
    <div className="text-[#FFFFFF]">
      {currentContent?.intro && (
        <p className="font-light font-jakarta text-[15px] leading-relaxed mb-8">
          {currentContent.intro}
        </p>
      )}

      {currentContent?.sections?.map((section, index) => {
        const sectionId = section?.heading
          ? generateSectionId(section.heading)
          : null;

        return (
          <div key={index} className="mb-10">
            {/* Heading */}
            {section?.heading && (
              <h2
                id={sectionId}
                className="text-[22px] font-medium text-[#D8D8D8] mb-4 scroll-mt-28"
              >
                {section.heading}
              </h2>
            )}

            {/* Paragraphs */}
            {section?.paragraphs?.map((paragraph, pIndex) => (
              <p
                key={pIndex}
                className="font-light text-[15px] leading-relaxed mb-4 text-[#E4E4E4]"
              >
                {paragraph}
              </p>
            ))}
            {/* LIST SECTION */}
            {section?.type === 'list' && section?.items && (
              <ul className="space-y-4 text-[15px] text-[#E4E4E4]">
                {section.items.map((item, i) => (
                  <li key={i} className="flex gap-3">
                    <span className="text-white mt-1.5">•</span>
                    <div>
                      <span className="font-semibold text-white">
                        {item?.title}
                      </span>
                      {item?.description && (
                        <span className="font-light">
                          {' '}
                          – {item.description}
                        </span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );
};
